// extracted by mini-css-extract-plugin
export default {"cls1":"ViewAllSuggestions-cls1___3874a927d905c9f4a05","cls2":"ViewAllSuggestions-cls2___3438df6be53ed292075 ViewAllSuggestions-cls1___3874a927d905c9f4a05"};